import { withTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import SelectWithLoader from '../../common/SelectWithLoader'

const StatusSelect = ({ options, value, onChange }) => {
  return (
    <div className='select'>
      <label className='select__label'>Status</label>
      <SelectWithLoader
        defaultValue={options.length === 1 ? options[0] : undefined}
        showIndicatorSeparator={false}
        value={value}
        options={options}
        onChange={onChange}
      />
    </div>
  )
}

export default withTranslation()(
  observer(StatusSelect)
)
